import { MobileBottomNavigationContainer, Provider } from '@cian/frontend-mobile-bottom-navigation';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from '../../utils/applicationContext';
import { userSelector } from '../../selectors';
import { locationIdSelector } from '../../selectors/locationIdSelector';

type TBottomNavigationContainerProps = {
  isEnabled: boolean;
};

export const BottomNavigationContainer: React.FC<TBottomNavigationContainerProps> = ({ isEnabled }) => {
  const {
    httpApi,
    logger,
    custom: { subdomain },
  } = useApplicationContext();

  const { isAuthenticated } = useSelector(userSelector);
  const locationId = useSelector(locationIdSelector);

  if (!isEnabled) {
    return null;
  }

  return (
    <Provider context={{ httpApi, logger }}>
      <MobileBottomNavigationContainer
        pageType="chats"
        subdomain={subdomain}
        region={locationId}
        isAuthenticated={isAuthenticated}
      />
    </Provider>
  );
};
